/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Pipe, PipeTransform} from '@angular/core';
import {StringMapWrapper} from '../facade/collection';
import {DateFormatter} from '../facade/intl';
import {DateWrapper, NumberWrapper, isBlank, isDate, isString} from '../facade/lang';
import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';

// TODO: move to a global configurable location along with other i18n components.
var defaultLocale: string = 'en-US';
export class DatePipe implements PipeTransform {
  /** @internal */
  static _ALIASES: {[key: string]: String} = {
    'medium': 'yMMMdjms',
    'short': 'yMdjm',
    'fullDate': 'yMMMMEEEEd',
    'longDate': 'yMMMMd',
    'mediumDate': 'yMMMd',
    'shortDate': 'yMd',
    'mediumTime': 'jms',
    'shortTime': 'jm'
  };


  transform(value: any, pattern: string = 'mediumDate'): string {
    if (isBlank(value)) return null;

    if (!this.supports(value)) {
      throw new InvalidPipeArgumentException(DatePipe, value);
    }

    if (NumberWrapper.isNumeric(value)) {
      value = DateWrapper.fromMillis(NumberWrapper.parseInt(value, 10));
    } else if (isString(value)) {
      value = DateWrapper.fromISOString(value);
    }
    if (StringMapWrapper.contains(DatePipe._ALIASES, pattern)) {
      pattern = <string>StringMapWrapper.get(DatePipe._ALIASES, pattern);
    }
    return DateFormatter.format(value, defaultLocale, pattern);
  }

  private supports(obj: any): boolean {
    if (isDate(obj) || NumberWrapper.isNumeric(obj)) {
      return true;
    }
    if (isString(obj) && isDate(DateWrapper.fromISOString(obj))) {
      return true;
    }
    return false;
  }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'date', pure: true}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
